import api from "@/utils/api";
import { tanDependencies } from "mathjs";
import moment from "moment";
const applyjs = {
  // 保单号去重
  unique(arr) {
    let newArr = [];
    for (let i = 0; i < arr.length; i++) {
      if (newArr.indexOf(arr[i]) === -1) {
        newArr.push(arr[i]);
      }
    }
    return newArr;
  },
  checkPolicyNo(item, index, type) {
    if (type == "0") {
      this.effectivePolicyList[index].checked = true;
      this.effectivePolicyList.map((item1, index1) => {
        if (index1 != index) {
          item1.checked = false;
        }
      });
    } else {
      this.hisPolicyList[index].checked = true;
      this.hisPolicyList.map((item1, index1) => {
        if (index1 != index) {
          item1.checked = false;
        }
      });
    }
    this.policyObj = item;
    let userInfo = JSON.parse(localStorage.getItem("baseInfo"));
    this.policyObj.empName = userInfo.Employee_name;
    // this.date=item.startDate?item.startDate.substring(0,4)+'-'+item.startDate.substring(5,7)+'-'+item.startDate.substring(8,10):'2000-01-01'
    console.log(this.policyObj, "保单切换");
    this.queryPersonByPolicy(item);
    this.bankCardInfo(this.policyObj.memberNo);
    this.getFileType();
    this.policyChoose = false;
  },
  // 根据保单最新生效日期排序
  arraySort(arr) {
    arr.sort(function(a, b) {
      return new Date(b.startDate) - new Date(a.startDate);
    });
  },
  // 获取文件类型
  getFileType() {
    let param = {
      applyType: "AUTH",
      payorCode: this.policyObj.payorCode,
      language: this.language
    };
    api
      .getFileType(param)
      .then(res => res.data)
      .then(data => {
        this.fileList = data.data;
        this.fileList.forEach(item => {
          item.id = "file_upload_" + item.type;
        });
      });
  },
  checkedData() {
    if (this.value == 0) {
      this.$message.error(this.$t("alertPrompt[10]"));
      return false;
    } else if (
      this.hospitalName &&
      this.hospitalName.replace(/[^x00-xFF]/g, "**").length > 400
    ) {
      this.$message.error(this.$t("alertPrompt[10]"));
      return false;
    }
    if (!this.date) {
      this.$message.error(this.$t("alertPrompt[11]"));
      return false;
    } else if (!this.category) {
      this.$message.error(this.$t("alertPrompt[19]"));
      return false;
    } else if (
      !this.judgevalue ||
      (this.judgevalue && !this.judgevalue.label)
    ) {
      this.$message.error(this.$t("alertPrompt[22]"));
      return false;
    }
    if (!this.estBills) {
      this.$message.error(this.$t("alertPrompt[21]"));
      return false;
    } else {
      let moneyReg = /^[0-9]\d*(\.\d+)?$/; // 预估费用
      if (!moneyReg.test(this.estBills)) {
        this.$message.error(this.$t("alertPrompt[16]"));
        return false;
      } else {
        if (this.category == "IP") {
          if (!this.estLos) {
            this.$message.error(this.$t("alertPrompt[20]"));
            return false;
          } else {
            if (!moneyReg.test(this.estLos)) {
              this.$message.error(this.$t("alertPrompt[16]"));
              return false;
            }
          }
        }
      }
    }
    if (
      this.policyObj.cancellationDate &&
      !this.compareDate(this.policyObj.cancellationDate, this.date)
    ) {
      this.$message.error(this.$t("alertPrompt[17]"));
      return false;
    }
    if (this.remark && this.remark.replace(/[^x00-xFF]/g, "**").length > 250) {
      this.$message.error(this.$t("alertPrompt[18]"));
      return false;
    }
    return true;
  },
  validData() {
    let msg = "";
    if (this.formData.name == "") {
      if (this.$i18n.locale == "zh-cn") {
        this.$message.error("姓名不能为空");
      } else {
        this.$message.error("The name can't be null");
      }
      return false;
    } else if (!this.formData.idNumber) {
      if (this.$i18n.locale == "zh-cn") {
        this.$message.error("证件号码不能为空");
      } else {
        this.$message.error("The Id number can't be null");
      }
      return false;
    } else if (!this.formData.bankNo) {
      if (this.$i18n.locale == "zh-cn") {
        this.$message.error("银行卡号码不能为空");
      } else {
        this.$message.error("The bank card number can't be null");
      }
      return false;
    } else if (!this.formData.bankCode || !this.formData.bankName) {
      if (this.$i18n.locale == "zh-cn") {
        this.$message.error("银行名称不能为空");
      } else {
        this.$message.error("The bank name can't be null");
      }
      return false;
    } else if (!this.formData.citycode || !this.formData.city) {
      if (this.$i18n.locale == "zh-cn") {
        this.$message.error("银行所在地不能为空");
      } else {
        this.$message.error("The bank address can't be null");
      }
      return false;
    }
    return true;
  },
  // 上传文件
  _uploadFile(fileData) {
    const { memberNo } = this.policyObj;
    const { imageType, data } = fileData;
    console.log(fileData);
    data.append("memberControlNo", memberNo);
    api.uploadMedFile(data).then(res => {
      const data = res.data;
      if (data.code !== 200) {
        data.msg && this.$toast(data.msg);
        return false;
      }
      const { fileKey, fileName, fileUrl } = data.data;
      let item = {
        imageName: fileName,
        imagKey: fileKey,
        imageUrl: fileUrl,
        imageType: imageType
      };
      this.uploadFileList.push(item);
    });
  },
  uploadPhoto(e, type) {
    // 利用fileReader对象获取file
    var file = e.target.files[0];
    var filesize = file.size / 1024;
    var filename = file.name;
    if (filesize > 20000) {
      if (this.language == "CHINAESE") {
        this.$message.error("上传文件大小超过20MB,请压缩后再试");
      } else {
        this.$message.error(
          "File size exceeds 20MB, please compress and try again"
        );
      }
    } else {
      let formData = new FormData();
      formData.append("file", file);
      this._uploadFile({ imageType: type, data: formData });
    }
    // 添加这两行可以上传同一文件
    document.querySelector("#file_upload_" + type).setAttribute("type", "text");
    document.querySelector("#file_upload_" + type).setAttribute("type", "file");
  },
  getBase64(file) {
    return new Promise((resolve, reject) => {
      let reader = new FileReader();
      let fileResult = "";
      reader.readAsDataURL(file);
      //开始转
      reader.onload = function() {
        fileResult = reader.result;
      };
      //转 失败
      reader.onerror = function(error) {
        reject(error);
      };
      reader.onloadend = function() {
        resolve(fileResult);
      };
    });
  },
  // 下一步
  next(step) {
    // this.reloadFileList()
    if (step == 1 && this.checkedData()) {
      this.stepActive = step + 1;
      this.steps[0].arrowBlue = true;
      this.steps[1].process = true;
      this.steps[1].icon = require("../../assets/medilinkPC/step_2_finish.png");
    } else if (step == 2) {
      let list = this.fileList.filter(item => item.isFill == 1);
      for (var i = 0; i < list.length; i++) {
        if (
          !this.uploadFileList.filter(item => item.imageType == list[i].type)
            .length > 0
        ) {
          list[i].ifUp = false;
          if (this.$i18n.locale == "zh-cn") {
            this.$message.error("请上传" + list[i].cName);
          } else {
            this.$message.error("Please upload " + list[i].eName);
          }
        } else {
          list[i].ifUp = true;
        }
      }
      if (list.filter(item => item.ifUp == false).length == 0) {
        this.stepActive = step + 1;
        this.steps[1].arrowBlue = true;
        this.steps[2].process = true;
        this.steps[2].icon = require("../../assets/medilinkPC/step_3_finish.png");
      }
    }
  },
  // 上一步
  preStep(step) {
    this.stepActive = step - 1;
    if (step == 1) {
      this.policyObj;
    }
    if (this.stepActive == 2) {
      this.steps[2].arrowBlue = false;
      this.steps[2].process = false;
      this.steps[2].icon = require("../../assets/medilinkPC/step_3_unfinish.png");
      this.steps[1].arrowBlue = true;
      this.steps[1].process = true;
      this.steps[1].icon = require("../../assets/medilinkPC/step_2_finish.png");
    } else if (this.stepActive == 1) {
      this.steps[2].arrowBlue = false;
      this.steps[2].process = false;
      this.steps[2].icon = require("../../assets/medilinkPC/step_3_unfinish.png");
      this.steps[1].arrowBlue = false;
      this.steps[1].process = false;
      this.steps[1].icon = require("../../assets/medilinkPC/step_2_unfinish.png");
      this.steps[0].arrowBlue = true;
      this.steps[0].process = true;
      this.steps[0].icon = require("../../assets/medilinkPC/step_1_finish.png");
    }
  },
  preview(index) {
    this.visible = true;
    this.baseImg = this.uploadFileList[index].imageUrl;
  },
  // 申请理赔
  submit() {
    let param = {
      banKaccno: this.policyObj.bankaccno,
      banKnm: this.policyObj.banknm,
      banKaccnm: this.policyObj.bankaccnm,
      providerName: this.hospitalName,
      endDate: this.policyObj.endDate,
      startDate: this.policyObj.startDate,
      invamt: this.amount,
      policyNo: this.policyObj.policyNo,
      insured: this.policyObj.insured,
      issueType: "2",
      diagnosis: this.judgevalue.label,
      docRcvdt: this.date,
      remark: this.remark,
      memberNo: this.policyObj.memberNo,
      fileInfo: {
        uploadType: "upload",
        list: this.uploadFileList
      },
      admissionType: this.category,
      language: this.language,
      cardNo: this.policyObj.cardNo,
      estBills: this.estBills
    };
    if (this.category == "IP") {
      param.estLos = this.estLos;
    }
    this.createIclaims(param);
  },
  createIclaims(param) {
    this.isLoading = true;
    api.applyPreAuth(param).then(res => {
      this.isLoading = false;
      if (res.data.code == "200") {
        this.$message.success(res.data.msg);
        setTimeout(() => {
          this.$router.push({ name: "PreAuthQuery" });
        }, 1000);
      } else {
        this.$message.error(res.data.msg);
      }
    });
  },
  back() {
    this.stepActive = 2;
    this.steps[3].arrowBlue = false;
    this.steps[3].process = false;
    this.steps[3].icon = require("../../assets/medilinkPC/step_4_unfinish.png");
    this.steps[2].arrowBlue = false;
    this.steps[2].process = false;
    this.steps[2].icon = require("../../assets/medilinkPC/step_3_unfinish.png");
    this.steps[1].arrowBlue = true;
    this.steps[1].process = true;
    this.steps[1].icon = require("../../assets/medilinkPC/step_2_finish.png");
  },
  relatChage(value) {
    let itemR = this.relationWithInsuredList.filter(
      item => value == item.value
    )[0];
    this.relativeTxt = itemR.text;
    this.relative = value;
  },
  reloadFileList() {
    this.uploadFileList = this.fileListUpload;
  },
  onChange(checked) {
    this.isAddCard = checked;
  },
  getcalimAppBaseIfo() {
    let userInfo = localStorage.getItem("baseInfo");
    if (userInfo == "undefined") {
      userInfo = "";
    }
    if (userInfo) {
      userInfo = JSON.parse(userInfo);
    } else {
      userInfo = {};
    }
    api
      .getPreAppBaseIfo({ applyType: "AUTH", language: this.language })
      .then(res => res.data)
      .then(data => {
        this.policyList = data.data.policyList;
        this.oriPolicyList = JSON.parse(JSON.stringify(data.data.policyList));
        this.oriPolicyList = this.oriPolicyList.map(item => {
          item.insured = item.empName;
          item.empName = userInfo.Employee_name || item.empName;
          return item;
        });
        this.oriPolicyList.sort(function(a, b) {
          return new Date(b.startDate) - new Date(a.startDate);
        });

        let mainExit = this.oriPolicyList.find(item => {
          return item.level == "1";
        });
        if (mainExit) {
          this.policyObj = mainExit;
        } else {
          this.policyObj = this.oriPolicyList[0];
        }
        // this.date=this.policyObj.startDate?this.policyObj.startDate.substring(0,4)+'-'+this.policyObj.startDate.substring(5,7)+'-'+this.policyObj.startDate.substring(8,10):'2000-01-01'
        this.queryPersonByPolicy(this.policyObj);
        this.getFileType();
      });
  },
  onDateChange(date, dateString) {
    this.date = dateString;
  },
  coverageChange(value) {
    let index = this.policyObj.coverageList.findIndex(
      item => value == item.type
    );
    let coverageInfo = this.policyObj.coverageList[index];
    this.cov_catg = coverageInfo.cov_catg;
    this.coverage = value;
  },
  bankCardInfo(memberNo) {
    this.memberNo = memberNo;
    this.formData.memberNo = this.memberNo;
    api
      .bankCardInfo({ memberNo: this.memberNo })
      .then(res => res.data)
      .then(data => {
        this.bankList = data.data;
        this.mainCardInfo();
      });
  },
  getBankInfoList() {
    api
      .getBankInfoList({ keyWord: "" })
      .then(res => res.data)
      .then(data => {
        this.bankCardInfoList = data.data;
        this.bankData = data.data;
      });
  },
  mainCardInfo() {
    // 确定主卡信息
    this.bankList.map(item => {
      if (item.isMainCard == 0) {
        this.mainCard = item;
      }
    });
  },
  // 解绑主卡
  unlock(empId) {
    if (this.bankList.length < 2) {
      if (this.$i18n.locale == "en-us") {
        this.$message.error(
          "Currently there is only one bank card in the claim settlement account, and it is not allowed to untie"
        );
      } else {
        this.$message.error("当前理赔款账户只有一张银行卡，不允许解绑");
      }
    } else {
      api
        .unbindbankCardInfo({ id: empId })
        .then(res => res.data)
        .then(data => {
          this.$message.success(data.msg);
        });
    }
  },
  // 删除银行卡
  deleteBankCardInfo(empId) {
    api
      .deleteBankCardInfo({ id: empId })
      .then(res => res.data)
      .then(data => {
        // this.$message.success(data.msg)
        this.$message.success("删除银行卡成功");
        this.bankCardInfo(this.memberNo);
      });
  },
  // 变更主领卡
  changebankCardInfo(data) {
    api.changebankCardInfo(data).then(res => {
      this.$message.success("变更主领卡成功", "Successful change of main card");
      this.bankCardInfo(this.memberNo);
      // this.ifshow = false;
    });
  },
  setMainCard(newMainId) {
    // 设置为主卡
    let data = {
      newMainId: newMainId,
      oldMainId: this.mainCard.empId
    };
    this.changebankCardInfo(data);
  },
  getCityInfo() {
    let param = {
      level: "2",
      refGrp: "STATE_CHN",
      city: this.area
    };
    api
      .getAreaInfo(param)
      .then(res => res.data)
      .then(data => {
        this.areaInfoList = data.data;
        this.addressData = data.data;
      });
  },
  getBrachOfBankInfoList() {
    let param = {
      bankCd: this.formData.bankCode,
      cityCode: this.formData.citycode
    };
    api
      .getBrachOfBankInfoList(param)
      .then(res => res.data)
      .then(data => {
        this.branchBankInfoList = data.data;
        this.branchData = data.data;
      });
  },
  fetchSelect(value, type) {
    if (timeout) {
      clearTimeout(timeout);
      timeout = null;
    }
    var timeout = setTimeout(this.fake(value, type), 300);
  },
  fake(value, type) {
    this.fetching = true;
    if (type == "name") {
      this.formData.bankCode = value.key;
      this.formData.bankName = value.label;
      this.bankData = this.bankCardInfoList.filter(
        item => item.Fdesc.indexOf(value) > -1
      );
    } else if (type == "address") {
      this.formData.citycode = value.key;
      this.formData.city = value.label;
      this.formData.bankDetail = "";
      this.formData.bankDailCode = "";
      this.branchValue = [];
      this.addressData = this.areaInfoList.filter(
        item => item.fdesc.indexOf(value) > -1
      );
      if (this.formData.bankCode && this.formData.citycode) {
        this.getBrachOfBankInfoList();
      }
    } else {
      this.formData.bankDailCode = value.key;
      this.formData.bankDetail = value.label;
      this.branchData = this.branchBankInfoList.filter(
        item => item.Fdesc.indexOf(value) > -1
      );
    }
  },
  handleSearch(value, type) {
    this.fetchSelect(value, type);
  },
  handleChange(value, type) {
    console.log(value, type, "切换");
    if (type == "name") {
      this.bankValue = value;
    } else if (type == "address") {
      this.addressValue = value;
    } else {
      this.branchValue = value;
    }
    this.fetchSelect(value, type);
  },
  saveBankInfo() {
    if (this.validData()) {
      api
        .bindBankInfo(this.formData)
        .then(res => res.data)
        .then(data => {
          this.$message.success(data.msg);
          // 添加银行卡成功后置空
          this.formData.name = "";
          this.formData.idNumber = "";
          this.formData.bankNo = "";
          this.formData.bankCode = "";
          this.formData.citycode = "";
          this.formData.bankDailCode = "";
          this.bankValue = [];
          this.addressValue = [];
          this.branchValue = [];
          this.bankCardInfo(this.memberNo);
        });
    }
  },
  removeFile(index) {
    this.uploadFileList.splice(index, 1);
    // localStorage.setItem('uploadParams',JSON.stringify(this.uploadFileList))
  },
  changeInput() {
    // 有效保单
    this.queryEffectivePolicy();
    // 历史保单
    this.queryHisPolicy();
  },
  cancel() {
    this.addVisible = false;
  },
  bindCardInfo() {
    if (this.form.password && this.form.cardNo) {
      api
        .bindCardInfo(this.form)
        .then(res => res.data)
        .then(data => {
          this.$message.success(data.msg);
          this.addVisible = false;
        });
    } else {
      if (this.$i18n.locale == "zh-cn") {
        this.$message.error("保险卡号或密码不能为空");
      } else {
        this.$message.error(
          "The insurance card or the password can't be null!"
        );
      }
    }
  },
  queryEffectivePolicy() {
    api
      .queryEffectivePolicy({ cardNo: this.cardNo })
      .then(res => res.data)
      .then(data => {
        this.effectivePolicyList = data.data;
      });
  },
  queryHisPolicy() {
    api
      .queryHisPolicy({ cardNo: this.cardNo })
      .then(res => res.data)
      .then(data => {
        this.hisPolicyList = data.data;
      });
  },
  addCard() {
    this.addVisible = true;
  },
  goWelfare(item, itemmain, type) {
    localStorage.setItem("corpCode", item.corpCode);
    localStorage.setItem("welfareParams", JSON.stringify(item));
    if (type) {
      this.$router.push({
        name: "Benefits",
        query: {
          description: itemmain.description,
          payorName: itemmain.payorName
        }
      });
    } else {
      this.$router.push({
        name: "Benefits"
      });
    }
  },
  onSelect(record) {
    this.selectedRowKeys = record;
    let index = record[0];
    this.bankInfo = this.bankList[index];
  },
  exam(index) {
    this.imgVisible = true;
    this.showImgList = this.fileList[index].templateList;
  },
  // 获取医院列表
  getProviderList(value) {
    api
      .getWebProviderList(this.queryForm)
      .then(res => res)
      .then(data => {
        if (data.data.code == "200") {
          this.fetchData = data.data.data.list;
          if (this.fetchData.length == 0) {
            this.fetchData = [];
            this.fetchData.push({ provider_name: value, provider_code: "" });
            console.log(this.fetchData, "this.fetchData===>");
          }
        } else if (data.data.code == "401") {
          this.fetchData = [];
          this.fetchData.push({ provider_name: value, provider_code: "" });
        } else {
          this.$message.error(data.data.msg);
        }
      });
  },
  hospitalChange(value) {
    this.value =
      !isNaN(value) && value != ""
        ? this.fetchData[value].provider_name
        : value;
    this.hospitalName = value.label;
  },
  hospitalBlur(value) {
    this.value = value;
  },
  fetch(value) {
    this.queryForm.provider_name = value;
    this.getProviderList(value);
  },
  queryPersonByPolicy(item) {
    let data = {
      memberNo: item.memberNo,
      policyNo: item.policyNo,
      startDate: item.startDate,
      endDate: item.endDate
    };
    api.queryPersonByPolicy(data).then(res => {
      this.insuredList = res.data.data;
      this.policyObj.insured = this.insuredList[0].empName;
    });
  },
  disabledDate(currentDate) {
    let start = moment("2000-01-01");
    let maxDate = moment();
    if (this.policyObj.startDate) {
      start = moment(
        this.policyObj.startDate.substring(0, 4) +
          "-" +
          this.policyObj.startDate.substring(5, 7) +
          "-" +
          this.policyObj.startDate.substring(8, 10)
      );
    }
    return currentDate && (currentDate > maxDate || currentDate < start);
  },
  compareDate(d1, d2) {
    console.log(d1, d2);
    if (d1 && d2) {
      if (typeof d2 == "string") {
        if (d2.indexOf("/") > -1) {
          if (
            moment(moment(d1).format("YYYY/MM/DD")).isBefore(
              moment(d2).format("YYYY-MM-DD")
            )
          ) {
            return false;
          } else {
            return true;
          }
        } else if (d2.indexOf("-") > -1) {
          if (
            moment(moment(d1).format("YYYY/MM/DD")).isBefore(
              moment(d2).format("YYYY/MM/DD")
            )
          ) {
            return false;
          } else {
            return true;
          }
        }
      } else {
        if (
          moment(moment(d1).format("YYYY/MM/DD")).isBefore(
            moment(d2).format("YYYY/MM/DD")
          )
        ) {
          return false;
        } else {
          return true;
        }
      }
    } else {
      return false;
    }
  },
  cancelAdd() {
    this.formData.name = "";
    this.formData.idNumber = "";
    this.formData.bankNo = "";
    this.formData.bankCode = "";
    this.formData.citycode = "";
    this.formData.bankDailCode = "";
    this.bankValue = [];
    this.addressValue = [];
    this.branchValue = [];
  },
  insuredChange(value) {
    this.policyObj.insured = value;
    let memberNo = this.insuredList.filter(item => item.empName == value)[0]
      .memberNo;
    let policyNo = this.policyObj.policyNo;
    let filterData = this.oriPolicyList.filter(
      item => item.policyNo == policyNo && item.memberNo == memberNo
    );
    if (filterData) {
      this.policyObj = filterData[0];
    }
    this.getFileType();
  },
  categoryChange(value) {
    this.category = value;
  },
  judgeChange(value) {
    this.judgevalue =
      !isNaN(value) && value != "" ? this.fetchJudgeData[value].name : value;
  },
  judgefetch(value) {
    let lan = this.$i18n.locale == "zh-cn" ? "CHINESE" : "ENGLISH";
    api.getDiagnosis({ diagnosis: value, language: lan }).then(res => {
      this.fetchJudgeData = res.data.data;
      if (this.fetchJudgeData.length == 0) {
        this.fetchJudgeData.push({ name: value });
      }
    });
  },
  judgeBlur(value) {
    this.judgevalue = value;
  },
  downFile() {
    let type = "AUAPP";
    api
      .getTemplatePre({ templateType: type })
      .then(res => res.data)
      .then(data => {
        let fileUrl = "";
        let fileName = "";
        if (this.$i18n.locale == "zh-cn") {
          fileUrl = data.data[0].temPlateUrl;
          fileName = data.data[0].temPlateName;
        } else {
          fileUrl = data.data[1].temPlateUrl;
          fileName = data.data[1].temPlateName;
        }
        window.open(fileUrl);
      });
  }
};

export default applyjs;
